import { INVESTMENT_PROFILE_TYPE_INDIVIDUAL } from "@components/Domain";

type Investment = {
  profileType?: string;
};

const isIndividualInvestment = ({ profileType }: Investment): boolean => {
  const isIndividual = profileType === INVESTMENT_PROFILE_TYPE_INDIVIDUAL;

  return isIndividual;
};

export default isIndividualInvestment;
